import { useClientSummaryData } from "../hooks/ClientSummaryContext";
import { Table } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import React from "react";

function ClientDetailsGrid() {
    const { clientSummaryData, clientSummaryError, clientSummaryIsLoading, factFindData, factFindError, factFindIsLoading } = useClientSummaryData();
    const isMasterAccountAmlMissing = clientSummaryData && clientSummaryData.isAMLMissing === true && clientSummaryData.isAMLExpired === false;
    const isMasterAccountAmlExpired = clientSummaryData && clientSummaryData.isAMLExpired === true && clientSummaryData.isAMLMissing === false;
    const notSetColour = { color: "red" };

    const clientDetails = React.useMemo(() => {
        if (!clientSummaryData || !factFindData) {
            return []
        }
        const { clientAccounts } = clientSummaryData
        const { clientAccounts: clientFactFindData } = factFindData
        return clientAccounts.map((el) => {
            const ffData = clientFactFindData.find((ff) => ff.clientAccountId === el.id);
            const isClientDeceased = el.status === 1;
            const isClientAMLExpired = moment(el.amlExpiryDate).isBefore(moment(), 'day');
            const isClientAMLMissing = el.amlUploadedDate === null;

            let amlStatus = '';
            let amlStatusStyle = { color: 'black' };
            if (isClientDeceased) {
                amlStatus = null;
            }
            else if (isClientAMLExpired) {
                amlStatus = 'AML Expired';
                amlStatusStyle = { color: "red" };
            }
            else if (isClientAMLMissing) {
                amlStatus = 'AML Missing';
                amlStatusStyle = { color: "red" };
            }
            else {
                amlStatus = 'AML Verified';
                amlStatusStyle = { color: "green" };
            }
            return {
                ...el,
                dob: ffData?.dateOfBirth,
                ni: ffData?.nationalInsuranceNumber,
                stage: ffData?.lifeStage,
                amlStatus,
                amlStatusStyle,
            };
        })
    }, [clientSummaryData, factFindData])

    if (clientSummaryIsLoading || factFindIsLoading) return (
        <Skeleton height={300} />
    )

    if (clientSummaryError || factFindError) return <p>Error loading data</p>;
    if (!clientSummaryData || !factFindData) {
        return null;
    }

    return (
        <div className="table-responsive">
            <Table bordered style={{ border: "1px" }}>
                <thead >
                    <tr>
                        <th>Name</th>
                        <th>AML Status</th>
                        <th>DOB</th>
                        <th>NI</th>
                        <th>Life Stage</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        clientDetails.map((clientData) => (
                            <tr key={clientData.id}>
                                <td>{clientData.forenames} {clientData.surname}</td>
                                <td><span style={clientData.amlStatusStyle}>{clientData.amlStatus}</span></td>
                                <td className="font-monospace">{clientData.dob ? moment(clientData.dob).format('YYYY-MM-DD') : <span style={notSetColour}>Not Set</span>}</td>
                                <td>{clientData.ni ? clientData.ni : <span style={notSetColour}>Not Set</span>}</td>
                                <td>{clientData.stage ? clientData.stage : <span style={notSetColour}>Not Set</span>}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
        </div >
    )
}

export default ClientDetailsGrid;